export default {
  name: 'population',
  key: 'population',
  attributes: {
    failed: {
      key: 'failed',
      name: 'population.failed',
    },
    outpost: {
      key: 'outpost',
      name: 'population.outpost',
    },
    lessThanMillion: {
      key: 'lessThanMillion',
      name: 'population.lessThanMillion',
    },
    severalMillion: {
      key: 'severalMillion',
      name: 'population.severalMillion',
    },
    hundredsOfMillions: {
      key: 'hundredsOfMillions',
      name: 'population.hundredsOfMillions',
    },
    billions: {
      key: 'billions',
      name: 'population.billions',
    },
    alien: {
      key: 'alien',
      name: 'population.alien',
    },
  },
};
